import { render, staticRenderFns } from "./ContainerDetails.vue?vue&type=template&id=f59229f2&scoped=true"
import script from "./ContainerDetails.vue?vue&type=script&lang=ts"
export * from "./ContainerDetails.vue?vue&type=script&lang=ts"
import style0 from "./ContainerDetails.vue?vue&type=style&index=0&id=f59229f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59229f2",
  null
  
)

export default component.exports